export default __webpack_public_path__ + "static/media/home-off.6f16c255.svg";